module.exports = __webpack_public_path__ + "img/H32-1.png";